import _ from 'lodash'

class QuotationFormLandscapeComponent {
    /** @ngInject */
    constructor(DeviceChecker) {
        this.isMobile = DeviceChecker.isMobile
    }

    onLandscapeDone($event) {
        this.onDispatch({ $event: { type: 'LANDSCAPE_DONE', isLandscapeDone: $event.landscapeDone } })
        if ($event.landscapeDone === true) {
            this.goToStepConsumption()
        }
    }

    goToStepConsumption() {
        this.onDispatch({ $event: { type: 'GO_TO_FORM_CONSUMPTION' } })
    }
}

export default {
    template: require('./quotationFormLandscape.jade')(),
    controller: QuotationFormLandscapeComponent,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationFormLandscape.js